import ApparelMenu from './SubComponents/apparelMenu'
import IndividualCycleIdSubmenu from './SubComponents/individualCycleIdSubmenu'
import CycleCountSidebar from './SubComponents/cycleCountSidebar'
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deepCopyFunction } from '../Utils/helpers'
import { getCategorySubCategoryListAction, getProductListByCategory } from '../Store/actions/apparelAction';
import { LoadingOverlay } from "../shared/loading-overlay";

const IndividualCycleId = () => {
  const locationProps = useLocation().state;
  
  const ApparelReducerState = useSelector((state: any) => state.ApparelReducerState);
  const { getMultipleCategoryListData, getMultipleCategoryListOnLoad, getProductListCategoryListOnLoad, getProductListCategoryData, createOrUpdateCycleCountLoad } = ApparelReducerState;
  const getCategory = getMultipleCategoryListData?.getCategorySubcategoryList?.categorySubcategoryData;
  const [single, setSingle] = useState<any>(1);
  const [productTextOnLoad, setProductTextOnLoad] = useState(false)
  const [searchTextOnLoad, setSearchTextOnLoad] = useState(false)
  const [availableCount, setAvailableCount] = useState<any>(0);
  // const [getProductListLoad, setGetProductListLoad] = useState(false);
  const [searchText, setSearchText] = useState(false)
  const [pendingButton, setPendingButton] = useState(1)
  const [statusRefIdOnClick, setStatusRefIdOnClick] = useState<any>(null);
  const [countIndex, setCountIndex] = useState(0)
  const [manualCount, setManualCount] = useState<any>(0);
  const [missingCount, setMissingCount] = useState<any>(0);
  const [productCategroryMappingId, setProductCategoryMappingId] = useState(0)

  const dispatch = useDispatch()

  const categoryListTemp: any = {
    searchText: "",
    isMultipleRecords: single,
    categoryAndSubCategoryMappingId: "",
    cycleCountJobId: "",
  }

  const [categoryList, setCategoryList] = useState<any>(deepCopyFunction(categoryListTemp))
  
  const searchTextApi = () => {
    let payload = {
      cycleCountJobId: locationProps?.data?.cycleCountJobId,
      statusRefId: locationProps?.data?.statusRefId == 3 ? 2 : pendingButton,
      isMultipleRecords: single,
      searchText: categoryList?.searchText,
      isCompleteStatus: locationProps?.data?.statusRefId == 1 ? 2 : locationProps?.data?.statusRefId
    }
    dispatch(getCategorySubCategoryListAction(payload))
    setSearchTextOnLoad(true);
  }

  // useEffect(() => {
  //   if (getProductListLoad && !getProductListCategoryListOnLoad) {
  //     if (getProductListCategoryData?.getProductListByCategorySubCategory !== null) {
  //       {
  //         setAvailableCount(getProductListCategoryData?.getProductListByCategorySubCategory.reduce((total:any, item:any) => total + item.availableCount ? parseInt(item.availableCount) : 0 ,0))
  //         setMissingCount(getProductListCategoryData?.getProductListByCategorySubCategory.reduce((total:any, item:any) => total + item.missingCount ? parseInt(item.missingCount) : 0 ,0))
  //       }
  //     }
  //     setGetProductListLoad(false);
  //   }
  // }, [getProductListLoad, getProductListCategoryListOnLoad])


  return (
    <div className="mz h-full overflow-y-auto">
      <ApparelMenu selectedKey="5" />
      <IndividualCycleIdSubmenu 
        searchTextApi={searchTextApi} 
        // single={single} 
        setSingle={setSingle} 
        data={locationProps} 
        // categoryList={categoryList}
        // getCategory={getCategory} 
        // getMultipleCategoryListOnLoad={getMultipleCategoryListOnLoad} 
        setPendingButton={setPendingButton}
        // statusRefIdOnClick={statusRefIdOnClick} 
        setStatusRefIdOnClick={setStatusRefIdOnClick} 
        setCountIndex={setCountIndex}
        // setManualCount={setManualCount} 
        // setMissingCount={setMissingCount} 
        // manualCount={manualCount} 
        // missingCount={missingCount}
        setProductCategoryMappingId={setProductCategoryMappingId}
        />

      <CycleCountSidebar searchTextApi={searchTextApi}
        setSingle={setSingle}
        single={single}
        foot={locationProps}
        categoryList={categoryList}
        setCategoryList={setCategoryList}
        setSearchText={setSearchText} setSearchTextOnLoad={setSearchTextOnLoad}
        searchTextOnLoad={searchTextOnLoad}
        getCategory={getCategory} 
        getMultipleCategoryListOnLoad={getMultipleCategoryListOnLoad}
        getProductListCategoryListOnLoad={getProductListCategoryListOnLoad}
        productTextOnLoad={productTextOnLoad} 
        setProductTextOnLoad={setProductTextOnLoad}
        availableCount={availableCount}
        missingCount={missingCount} cycleCountJobId={locationProps} statusRefIdOnClick={statusRefIdOnClick}
        setStatusRefIdOnClick={setStatusRefIdOnClick}
        setCountIndex={setCountIndex} countIndex={countIndex} setMissingCount={setMissingCount} setManualCount={setManualCount}
        manualCount={manualCount} pendingButton={pendingButton}
        setProductCategoryMappingId={setProductCategoryMappingId}
        productCategroryMappingId={productCategroryMappingId}
      />
      <LoadingOverlay loading={createOrUpdateCycleCountLoad} />
    </div>
  )
}

export default IndividualCycleId